
  <div class="card card-body">
    <form [formGroup]="form">
      <div class="row">
        <div class="col-sm-4 col-md-4 col-lg-3 p-4">
          <mat-slide-toggle
            [color]="'primary'"
            required="false"
            [checked]="false"
            formControlName="processamentoOnlineAtivo"> Execução on-line</mat-slide-toggle>
        </div>
        <div class="col-sm-5 col-lg-4 col-xl-2 col-xxl-2">
          <lib-datepicker-day #execucaoVigenciaDataInicio [schema]="dataInicioAssociacaoSchema"></lib-datepicker-day>
        </div>
        <div class="col-1 p-3">
          <button
            mat-mini-fab
            color="primary"
            type="button"
            title="Adicionar"
            [disabled]="!form.get('dataInicioAssociacao').valid"
            (click)="marcaAssociacao(form.value)">
            <i class="fas fa-plus-circle" aria-hidden="true"></i>
          </button>
        </div>
      </div>
    </form>
    <div class="row mt-5">
      <div class="col-12">
        <table class="table label-maps table-striped table-bordered table-hover table-responsive-sm">
          <thead>
            <tr>
              <th>Carteira</th>
              <th>Regra</th>
              <th>Execução</th>
              <th>Data início associação</th>
              <th class="text-center">Ação</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let s of getAssociacao()">
              <td>{{ s.carteiraNome }}</td>
              <td>{{ s.regraNome }}</td>

              <td *ngIf="!associacaoIsEqual(associacaoOriginal, s)">
                <mat-slide-toggle [color]="'primary'" [(ngModel)]="s.processamentoOnlineAtivo" [disabled]="true"> On-line</mat-slide-toggle>
              </td>
              <td *ngIf="associacaoIsEqual(associacaoOriginal, s)">
                <mat-slide-toggle [color]="'primary'" [(ngModel)]="associacaoEdicao.processamentoOnlineAtivo"> On-line</mat-slide-toggle>
              </td>

              <td *ngIf="!associacaoIsEqual(associacaoOriginal, s)">{{ s.dataInicioAssociacao | date: "dd/MM/yyyy" }}</td>
              <td *ngIf="associacaoIsEqual(associacaoOriginal, s)">
                <mat-form-field style="width: 90px;">
                  <input matInput libMask="00/00/0000" [(ngModel)]="dataEdicao"/>
                </mat-form-field>
              </td>
              <td class="pt-1 pb-1" *ngIf="!associacaoIsEqual(associacaoOriginal, s)">
                <div class="d-flex flex-row justify-content-center">
                  <div class="pr-3">
                    <button mat-icon-button type="button" (click)="setModoEdicao(s)" title="Editar">
                      <i class="fas fa-edit" aria-hidden="true"></i>
                    </button>
                  </div>
                  <div>
                    <button
                      mat-icon-button
                      color="warn"
                      type="button"
                      (click)="remove(s)"
                      title="Excluir">
                      <i class="fas fa-trash" aria-hidden="true"></i>
                    </button>
                  </div>
                </div>
              </td>
              <td *ngIf="associacaoIsEqual(associacaoOriginal, s)">
                <div class="d-flex flex-row justify-content-center">
                  <div class="pr-3">
                    <button mat-icon-button type="button" (click)="save()" title="Salvar">
                      <i class="fas fa-save" aria-hidden="true"></i>
                    </button>
                  </div>
                  <div>
                    <button mat-icon-button type="button" class="btn btn-default " (click)="setModoEdicao(null)" title="Cancelar">
                      <i class="fas fa-undo" aria-hidden="true"></i>
                    </button>
                  </div>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
        <div class="d-flex justify-content-center">
          <maps-pagination
            [items]="validacaoSelecaoModels.length/10"
            *ngIf="
              this.associacaoService.getPage() &&
              this.associacaoService.getPage() > 0
            "
            (pageSend)="receiverPage($event)"
          ></maps-pagination>
        </div>
      </div>
    </div>
  </div>
